import { render, staticRenderFns } from "./netbarmanage.vue?vue&type=template&id=4e5a1107&scoped=true"
import script from "./netbarmanage.vue?vue&type=script&lang=js"
export * from "./netbarmanage.vue?vue&type=script&lang=js"
import style0 from "./netbarmanage.vue?vue&type=style&index=0&id=4e5a1107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a1107",
  null
  
)

export default component.exports